import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { saveAs } from 'file-saver';

import { GlobalsService } from '../_services/globals.service';
import { KeycloakService } from '../login/keycloak.service';

@Injectable({ providedIn: 'root' })
export class ReportsService {
  private serviceDialogOpenSubject = new Subject<void>();
  private serviceDialogOpenObservable = this.serviceDialogOpenSubject.asObservable();

  private generatingReportSubject = new Subject<boolean>();
  private generatingReportObservable = this.generatingReportSubject.asObservable();

  constructor(
    private gs: GlobalsService,
    private http: HttpClient,
    private keycloakService: KeycloakService
  ) {}

  public openReportComponent(): void {
    this.serviceDialogOpenSubject.next();
  }

  public subscribeOpenReportComponent(): Observable<void> {
    return this.serviceDialogOpenObservable;
  }

  public setGeneratingReport(value: boolean): void {
    this.generatingReportSubject.next(value);
  }

  public subscribeGeneratingReportListener(): Observable<boolean> {
    return this.generatingReportObservable;
  }

  public exportFile(report: string, format: string, params: string): Observable<Blob> {
    const url =
      `${this.gs.getRestUrl()}/api/lek/report` +
      `?report=${encodeURIComponent(`${report}.${format}`)}` +
      `&outfilename=${encodeURIComponent(`${report}.${format}`)}` +
      `&params=${encodeURIComponent(params)}`;

    return this.http.get(url, {
      withCredentials: false,
      responseType: 'blob'
    });
  }

  public exportViriFile(format: string, params: string, outfilename: string): Observable<Blob> {
    const url =
      `${this.gs.getRestUrl()}/api/lek/viri` +
      `?ext=${encodeURIComponent(format)}` +
      `&outfilename=${encodeURIComponent(`${outfilename}.${format}`)}` +
      `&params=${encodeURIComponent(params)}`;


    return this.http.get(url, {
      withCredentials: false,
      responseType: 'blob'
    });
  }

  public exportPosebniCilji(format: any): void {
    this.http
      .get(`/assets/obrazci/posebnicilji.${format}`, {
        withCredentials: false,
        responseType: 'blob'
      })
      .subscribe((d: Blob) => this.downloadFile(d, `posebni_cilji.${format}`, format));
  }

  public downloadFile(data: Blob, fn: string, format: string): void {
    const blob = data.type ? data : new Blob([data], { type: this.inferMime(format) });
    saveAs(blob, fn);
  }

  private inferMime(format: string): string {
    const f = (format || '').toLowerCase();
    switch (f) {
      case 'pdf':
        return 'application/pdf';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      default:
        return `application/${f || 'octet-stream'}`;
    }
  }

  public getDocumentTypes(): Array<{ label: string; value: string }> {
    return [
      { label: '2016', value: '2016' },
      { label: '2017', value: '2017' },
      { label: '2018', value: '2018' },
      { label: '2019', value: '2019' }
    ];
  }
}